export class CountryTableData {
  name: string = null;
  code: string = null;
  dedicatedFinancialContributionsToEOSCLinkedToPolicies: string = null;
  hasAppointedMandatedOrganization: string = null;
  EOSCRelevantPoliciesInPlace: string[] = [];
  mapPointData: string[] = [];

  oaSharePublicationsAffiliatedPeerReviewed: number = null;
  oaSharePublicationsAffiliated: number = null;
  oaSharePublicationsDepositedPeerReviewed: number = null;
  oaSharePublicationsDeposited: number = null;


  // datasets: number = null;
  // software: number = null;
  // other: number = null;
  // repositories: number = null;
  // journals: number = null;
  // policies: number = null;
  // pid: Indicator;
  // licence: Indicator;
  // gold: Indicator;
  // green: Indicator;
  // cc_licence: Indicator;
  // abstract: Indicator;
  // funders_collab: Indicator;
  // projects_collab: Indicator;
  // authors_collab: Indicator;
}
